
import { Component, Vue } from 'vue-property-decorator';

import Trigger from '@/components/shared/MinimalisticTrigger.vue'
import ModalSaved from './ModalSaved.vue'

import { mapGetters, mapActions } from 'vuex'

const getInitialModalAlertParams = () => {
  return {
    show: false,
    options: null
  }
}

@Component({
  name: 'ProfileNotificationsSettings',
  components: {
    Trigger,
    ModalSaved
  }
})
export default class ProfileNotificationsSettings extends Vue {
  
  private modals = {
    alert: getInitialModalAlertParams()
  };

  get enabledProp() {
    return this.enabled;
  };

  set enabledProp(val) {
    if (!val && this.activePeriod) {
      const periodIdToDisable = this.activePeriod

      this.$store.commit('user/notifications/updateStatePeriod', {
        id: periodIdToDisable,
        is_active: false
      })
    }
    this.set_change(true);
    this.$store.commit('user/notifications/updateStateEnable', val)
  };

  get activePeriod() {
    const p = this.periods.find(p => p.is_active === true)

    return p ? p.id : null
  };

  set activePeriod(val) {
    const oldPeriod = this.periods.find(p => p.is_active === true)

    if (oldPeriod) {
      this.$store.commit('user/notifications/updateStatePeriod', {
        id: oldPeriod.id,
        is_active: false
      })
    }
    this.set_change(true);
    this.$store.commit('user/notifications/updateStatePeriod', {
      id: val,
      is_active: true
    })
  };

  get periods() {
    return this.$store.getters['user/notifications/periods'];
  };

  get enabled() {
    return this.$store.getters['user/notifications/enabled'];
  };

  public save () {
    this.set_change(false);
    this.$store.dispatch('user/notifications/update', {
      apiData: {
        enabled: this.enabledProp,
        periods: this.periods
      },
      rethrowError: true
    }).then(r => {
      this.$noty.success(this.$tr('profile.notifications.save_success'))
    }).catch(e => {
      this.$noty.error(this.$tr('profile.notifications.save_error'))
    });
  };

  public successSaved () {
    this.modals.alert = {
      show: true,
      options: {
        type: 'success',
        bodyKey: 'profile.notifications.modals.saveSuccess.text'
      }
    }
    setTimeout(() => { this.clearModalAlertData() }, 1500)
  };

  public clearModalAlertData () {
    this.modals.alert = getInitialModalAlertParams()
  };

  public set_change(val) {
    this.$store.commit('user/set_change_user', val);
  };

  public fetchPeriods() {
    this.$store.dispatch('user/notifications/fetch');
  };

  beforeMount () {
    this.fetchPeriods()
  };

  mounted () {
    // this.$parent.$parent.$parent.$on('save', this.save)
  };

  beforeDestroy () {
    // this.$parent.$parent.$parent.$off('save')
  };
}
